/**
 * Converts HTML string to clean text.
 * Removes img tags, replaces block tags with newlines, strips other tags,
 * decodes basic entities, and cleans up whitespace.
 * @param html The input HTML string.
 * @returns The cleaned text string.
 */
export function removeHtmlTag(html?: string): string {
  if (!html) {
    return "";
  }

  let text = html;

  // 1. Remove images
  text = text.replace(/<img[^>]*>/g, "");

  // 2. Replace block elements and line breaks with newlines
  text = text.replace(/<br\s*\/?>/gi, "\n"); // Replace <br>
  text = text.replace(
    /<\/(p|div|h[1-6]|li|blockquote|pre|hr|table|tr|td|th)[^>]*>/gi,
    "\n"
  ); // Replace closing block tags

  // 3. Remove all remaining HTML tags
  text = text.replace(/<[^>]*>/g, "");

  // 4. Decode basic HTML entities
  text = text.replace(/&nbsp;/g, " ");
  text = text.replace(/&amp;/g, "&");
  text = text.replace(/&lt;/g, "<");
  text = text.replace(/&gt;/g, ">");
  text = text.replace(/&quot;/g, '"');
  text = text.replace(/&#39;/g, "'");

  // 5. Clean up extra whitespace and newlines
  text = text.replace(/\n{2,}/g, "\n"); // Replace multiple newlines with single one
  text = text.trim(); // Trim leading/trailing whitespace

  return text;
}
